export default function Architektura(props) {
  return (
    <h2 className="pd-panel__title" id="a11y-architektura">
      {props.children}
    </h2>
  );
}
